export const ENDPOINT_ENDPOINT_MONOPALETTE_INFO_DEV =
  '/api/v1/supply/monopalletInfo';
export const ENDPOINT_MONOPALETTE_INFO_PROD = window.MONOPALETTE_INFO_ENDPOINT;
